const validateReponse = response => {
  if (response?.data?.state === 'completed') return true;
  else if (response?.data?.state === 'failed') return 'failed';
  else return false;
};

export default validateReponse;
